
















































































import { Component, Vue, Inject } from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../../lib/ajax'
import AbpBase from '../../../../lib/abpbase'
import QuickTable from "../../../../components/table/table.vue";
import DownloadList from "../../../../components/tools/downloadList.vue";
import Appconst from '../../../../lib/appconst';
@Component({
	name:'instituteManage',
	components: {
		QuickTable,
		DownloadList
	}
})
export default class InstituteManage extends AbpBase  {
    initData:any = {
    	showModal: false,		// 弹窗显示状态
    	formLoading: false,		// 表单提交状态
    	searchData: {
    		InstituteName: ''
    	},
    	showDetailModal: false,
    	details: {},
    	detailData: {
    		creatorUser: {},
    		creatorDep: {},
    		attachs: []
    	},
    	columns: [
            {
            	title: '序号',
                type: 'index',
                width: 62,
                align: 'center'
            },
            {
                title: '发布部门',
                width: 168,
                render: (h:any, params:any) => {
                	return h('span', params.row.creatorDep ? params.row.creatorDep.displayName : '');
                }
            },
            {
                title: '发布人',
                width: 128,
                render: (h:any, params:any) => {
                	return h('span', params.row.creatorUser ? params.row.creatorUser.name : '');
                }
            },
            {
                title: '制度/文件名称',
                key: 'instituteName'
            },
            {
                title: '发布时间',
                width: 218,
                key: 'creationTime',
				render: (h:any, params:any) => {
					return h('span', this.formatDate(params.row.creationTime));
				}
            },
            {
                title: '操作',
                width: 130,
                render: (h:any, params:any) => {
                	return h('span', [
                		h('Button', {
                			props: {
                				type: 'primary',
                				size: 'small'
                			},
							on: {
								click: () => {
									this.handleGetDetail(params.row.id);
								}
							}
                		}, '详情'),
                		/*h('Button', {
                			props: {
                				type: 'error',
                				size: 'small'
                			},
                			style: {
                				marginLeft: '10px'
                			},
							on: {
								click: () => {
									this.handleDelete(params.row.id);
								}
							}
                		}, '删除')*/
                	])
                }
            }
		],
		fileUrl: Appconst.fileUrl
    }
    formData:any = {
    	instituteName: '',
		remark: '',
		attachs: []
    }
    ruleValidate:any = {
    	instituteName: [
            { required: true, message: '请输入制度名称', trigger: 'blur' }
        ]
    }
    GetData() {
        (this as any).$refs.table.GetData();
    }
    formatDate(d:any) {
    	if(!d) return '';
    	if(typeof d == 'string') {
    		d = new Date(d);
    	}
    	return d.getFullYear() +'-'+ (d.getMonth() + 1) +'-'+ d.getDate();
    }
    // 新增
    async handleSubmit() {
    	(this.$refs.form as any).validate(async (valid:boolean)=>{
            if(valid){
            	let params:any = {
            		instituteName: this.formData.instituteName,
					remark: this.formData.remark
            	}
            	// 格式化材料文件
    			params.attachs = (this as any).$refs.uploadFile.fileList.map((res:any) => {
    				return res.response.result;
    			})
    			
    			this.initData.formLoading = true;
                await Ajax.post('/api/services/app/Institute/CreateAsync', params).then((res:any)=>{
	                this.$Message.success('提交成功!');
	                this.initData.formLoading = false;
	                this.initData.showModal = false;
                	this.GetData();
	            }).catch(() => {
	            	this.initData.formLoading = false;
	            })
            }
        })
    }
    async handleDelete(id:any) {
    	this.$Modal.confirm({
            title: '操作确认',
            content: '是否确认删除此制度？',
            onOk: () => {
                Ajax.delete('', {params: {Id: id}}).then((res:any)=>{
	                this.$Message.success('删除成功!');
                	this.GetData();
	            })
            }
        });
    }
    handleClearForm(flog:any) {
    	if(!flog) {
    		this.initData.showModal = false;
    		(this as any).$refs.uploadFile.clearFiles();
    		(this as any).$refs.form.resetFields();
    	}
    }
    // 获取详情
    async handleGetDetail(id:any) {
    	if(this.initData.details[id]) {
    		this.initData.detailData = this.initData.details[id];
    		this.initData.showDetailModal = true;
    		return;
    	}
    	await Ajax.get('/api/services/app/Institute/GetDetailAsync', {params: {id: id}}).then((res:any)=>{
            this.initData.details[id] = res.data.result;
            this.initData.detailData = res.data.result;
    		this.initData.showDetailModal = true;
        })
    }
}
